import { isDefined } from '@app/utils/is';
import { IconComponent } from '@typings';
import React from 'react';

interface Props {
  title: string;
  icon?: IconComponent;
}

export const ListItemHeader = ({ title, icon: Icon, children }: React.PropsWithChildren<Props>) => {
  return (
    <div className="grid w-full grid-cols-[1fr,auto] items-center gap-2">
      <div className="flex items-center gap-1 overflow-hidden">
        <div className="truncate body-4">{title}</div>
        {isDefined(Icon) && (
          <div className="size-4 rounded-full bg-neutral-98 p-0.5">
            <Icon className="h-3 w-3 text-neutral-40" />
          </div>
        )}
      </div>
      <div className="flex gap-2">{children}</div>
    </div>
  );
};
